/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { sumBy } from 'lodash';

import { t } from '../../../../modules/infra/i18n';
import Date from '../../../common/date';
import Money from '../../../common/money';

const getActionsMap = () => ({
  newInventory: t('products:reports.inventory.actions.new_inventory'),
  damaged: t('products:reports.inventory.actions.damaged'),
  stockTaking: t('products:reports.inventory.actions.stock_taking'),
  returned: t('products:reports.inventory.actions.returned'),
  retail: t('products:reports.inventory.actions.retail'),
  backbar: t('products:reports.inventory.actions.backbar'),
  other: t('products:reports.inventory.actions.other'),
});

export default items => {
  const actionsMap = getActionsMap();
  
  return [
    {
      Header: t('products:reports.inventory.date_header'),
      accessor: 'dateTime',
      className: 'u-text-left',
      Cell: ({ value }) => <Date>{value}</Date>,
      Footer: t('products:reports.inventory.total_footer'),
    },
    {
      Header: t('products:reports.inventory.product_name_header'),
      accessor: 'productName',
    },
    {
      Header: t('products:reports.inventory.sku_header'),
      accessor: 'productSku',
    },
    {
      Header: t('products:reports.inventory.brand_header'),
      accessor: 'productBrand',
    },
    {
      Header: t('products:reports.inventory.category_header'),
      accessor: 'productCategory',
    },
    {
      Header: t('products:reports.inventory.previous_inventory_header'),
      accessor: 'previousInventory',
    },
    {
      Header: t('products:reports.inventory.new_inventory_header'),
      accessor: 'newInventory',
    },
    {
      Header: t('products:reports.inventory.supply_price_header'),
      accessor: 'supplyPrice',
      Cell: ({ value }) => <Money>{value}</Money>,
    },
    {
      id: 'total',
      Header: t('products:reports.inventory.total_header'),
      Footer: () => <Money>{sumBy(items, 'total')}</Money>,
      accessor: 'total',
      Cell: ({ value }) => <Money>{value}</Money>,
    },
    {
      Header: t('products:reports.inventory.action_header'),
      accessor: 'action',
      Cell: ({ value }) => actionsMap[value],
    },
    {
      Header: t('products:reports.inventory.description_header'),
      accessor: 'description',
      minWidth: 200,
      Cell: ({ value }) => <div className="u-ws-normal">{value}</div>,
    },
  ];
};
